module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAT4AAAACAgMAAAC8mVjBAAAACVBMVEV5SOp4SOt5SOovGHvmAAAAAnRSTlO/QGMSPt8AAAATSURBVAjXY/BaRVUgwKBFXQMbAArzaJ0qGpeZAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pagess/gdd102/h2-8.png
// module id = Nd3w
// module chunks = 1